import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 3v6.75h1.5V5.578L10.922 12 4.5 18.422V14.25H3V21h6.75v-1.5H5.578L12 13.078l6.422 6.422H14.25V21H21v-6.75h-1.5v4.172L13.078 12 19.5 5.578V9.75H21V3h-6.75v1.5h4.172L12 10.922 5.578 4.5H9.75V3H3z" fill="#fff" /></svg>);